// Shared look for the Limited Access UI. Values are the same light frosted-glass tokens the
// Global Header uses (AppHeader.jsx HEADER_GLASS_CSS, data-c30-glass="light"), plus the
// Encon Group brand colours from the Encon AI Brand Template.

export const ENCON_ORANGE = '#ee7203';
export const ENCON_BLACK = '#1d1d1b';
export const ENCON_GREY = '#9d9d9c';
export const BODY_TEXT = '#1f2937';
export const MUTED_TEXT = '#6b7280';

// Brand typeface with the documented web-safe fallback.
export const LIMITED_FONT = "Gotham, Arial, Helvetica, sans-serif";

// Drag-and-drop payload types (quick link from the home card -> sidebar, and sidebar reordering).
export const QUICK_LINK_MIME = 'application/x-c30-quicklink';
export const PINNED_MIME = 'application/x-c30-pinned';

// Frosted glass surface (sidebar rail, home cards).
export const GLASS_STYLE = {
  background: 'linear-gradient(160deg, rgba(255,255,255,0.96) 0%, rgba(255,246,238,0.70) 55%, rgba(255,255,255,0.86) 100%)',
  border: '1px solid rgba(238,114,3,0.30)',
  boxShadow: 'inset 0 1.5px 0 rgba(255,255,255,0.95), inset 0 -1px 0 rgba(238,114,3,0.12), 0 4px 14px rgba(29,29,27,0.10), 0 1px 3px rgba(29,29,27,0.08)',
  backdropFilter: 'blur(16px) saturate(1.6)',
  WebkitBackdropFilter: 'blur(16px) saturate(1.6)',
};

// Larger content cards sit a little more transparent so the faded fleet photo shows through.
export const GLASS_CARD_STYLE = {
  ...GLASS_STYLE,
  background: 'linear-gradient(160deg, rgba(255,255,255,0.90) 0%, rgba(255,246,238,0.62) 55%, rgba(255,255,255,0.78) 100%)',
};

// Same orange -> transparent -> orange gradient the Global Sub-Header uses, so page sub-header
// content (which is styled for that bar) keeps working when it moves into the limited top bar.
export const TOP_BAR_GRADIENT = 'linear-gradient(90deg, #ee7203 0%, rgba(238,114,3,0) 32%, rgba(238,114,3,0) 68%, #ee7203 100%)';
